import { render, staticRenderFns } from "./C2cBuy.vue?vue&type=template&id=143def54&scoped=true&"
import script from "./C2cBuy.vue?vue&type=script&lang=js&"
export * from "./C2cBuy.vue?vue&type=script&lang=js&"
import style0 from "./C2cBuy.vue?vue&type=style&index=0&id=143def54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143def54",
  null
  
)

export default component.exports